import { Box, Button, Typography } from '@mui/material';
import { IComponentCss } from '@tap/mui-ui';
import { IApiUserAccount, IssueUploadingUsersReportResult, userService } from '@tap/data-providers';
import { ReportGrid } from '@tap/mui-ui/src/XGridTable/ReportGrid';
import { dateTimeHelper } from '@tap/utils';

/*
*   Таблица "Загрузка пользователя" для заявок
*/

// Цвета для ячеек со значениями
const css: IComponentCss = {
    tableWrap: {
        position: 'relative',
        height: 'calc(100vh - 200px)',
        width: 1,
        '& .table-wrap.is-value': {
            backgroundColor: '#FBDBB5',
            borderBottomColor: '#FBDBB5',
        },
        '& .table-wrap.is-red-value': {
            backgroundColor: '#FFBDBD',
            borderBottomColor: '#FFBDBD',
        },
    },
    optionsButton: {
        zIndex: 1,
        position: 'absolute',
        right: '4px',
        top: '5px',
        height: '28px',
    },
    titleStyle: {
        marginBottom: '15px',
        fontSize: '20px',
    },
};

type IssueUploadingUsersTableProps = {
    executor: IApiUserAccount,
    reportData: IssueUploadingUsersReportResult,
    onOptionsButtonClick: () => void,
}

const getReportData = (reportData: IssueUploadingUsersReportResult) => {
    if (!reportData?.rows?.length) return [];

    return reportData.rows.map((row, idx) => ({
        ...row,
        id: idx,
    }));
}


export const IssueUploadingUsersTable = ({ executor, reportData, onOptionsButtonClick }: IssueUploadingUsersTableProps) => {
    const rowList = getReportData(reportData);

    return (
        <>
            <Typography sx={css.titleStyle}>Отчёт о рабочей загрузке для пользователя: {userService.getUserFIO(executor)}</Typography>
            <Box sx={css.tableWrap}>
                <Button
                    size='small'
                    sx={css.optionsButton}
                    onClick={onOptionsButtonClick}
                >
                    Параметры отчёта
                </Button>
                <ReportGrid
                    columns={[
                        {
                            field: 'department',
                            headerName: 'Цех и участок',
                            sortable: false,
                            flex: .3,
                            valueGetter: (_val, row) => row.department ? `${row.department.manufactory}.${row.department.sector}` : '-',
                            renderCell: cellParams => cellParams.row.department ? `${cellParams.row.department.manufactory}.${cellParams.row.department.sector}` : '-',
                        },
                        {
                            field: 'issueCount',
                            headerName: 'Назначенные заявки',
                            sortable: false,
                            flex: .5,
                            type: 'number',
                        },
                        {
                            field: 'estimateMin',
                            headerName: 'Трудоёмкость',
                            sortable: false,
                            width: 100,
                            flex: .2,
                            type: 'number',
                            valueGetter: (_val, row) => row.estimateMin
                                ? dateTimeHelper.timeFormat(row.estimateMin * 60 * 1000)
                                : '-',
                            renderCell: cellParams => cellParams.row.estimateMin
                                ? dateTimeHelper.timeFormat(cellParams.row.estimateMin * 60 * 1000)
                                : '-',
                        },
                    ]}
                    rows={rowList}
                    tableProps={{
                        rowHeight: 22,
                    }}
                />
            </Box>
        </>
    );
}

